import { ImageWithFallback } from '@/components/shared/NextImageFallback';
interface ImageWithBadgeProps {
  mainImageSrc: string;
  badgeImageSrc: string;
  size?: number; // in px
  badgeSize?: number;
  key?: string;
}
export default function ImageWithBadge({
  mainImageSrc,
  badgeImageSrc,
  size,
  badgeSize,
  key
}: ImageWithBadgeProps) {
  return <div className='relative inline-block' data-sentry-component="ImageWithBadge" data-sentry-source-file="ImageWithBadge.tsx">
      <ImageWithFallback key={key + mainImageSrc} src={mainImageSrc} width={100} height={100} alt='main-image' className={`rounded-full object-cover ${size ? `w-[${size}px] h-[${size}px]` : 'w-[18px] h-[18px]'}`} data-sentry-element="ImageWithFallback" data-sentry-source-file="ImageWithBadge.tsx" />
      <div className='absolute bottom-0 right-0'>
        <ImageWithFallback key={key + badgeImageSrc} src={badgeImageSrc} width={100} height={100} alt='Badge' className={`rounded-full ${badgeSize ? `w-[${badgeSize}px] h-[${badgeSize}px]` : 'w-[8px] h-[8px]'} bg-black `} data-sentry-element="ImageWithFallback" data-sentry-source-file="ImageWithBadge.tsx" />
      </div>
    </div>;
}